import { Selection, Select, EffectComposer, Outline } from '@react-three/postprocessing';
import { ReactNode } from 'react';
import { useSceneSelection } from './useSceneSelection';

interface Props {
  children: ReactNode;
  enabled?: boolean;
}

export function SelectionOutline({ children, enabled = true }: Props) {
  const hovered = useSceneSelection((s) => s.hoveredPartRef);
  const selected = useSceneSelection((s) => s.selectedPartRef);

  if (!enabled) return <>{children}</>;
  return (
    <Selection>
      <EffectComposer multisampling={4} autoClear={false}>
        <Outline blur edgeStrength={4} visibleEdgeColor={0x22d3ee} hiddenEdgeColor={0x0a1128} />
      </EffectComposer>
      <SelectableGroup hovered={hovered} selected={selected}>
        {children}
      </SelectableGroup>
    </Selection>
  );
}

function SelectableGroup({
  children,
  hovered,
  selected,
}: {
  children: ReactNode;
  hovered: string | null;
  selected: string | null;
}) {
  const refs = [hovered, selected].filter(Boolean) as string[];
  return <Select enabled={refs.length > 0}>{children}</Select>;
}
